import { ColDef } from 'ag-grid-community';

import { AggFunc } from '../../constants';

export interface GridFieldOptions extends ColDef {
  abbreviatedHeaderName?: string;
  zeroOrNegativeMessageField?: string;
  customAggFunc?: (rowData: any[]) => string;
  groupAggFunc?: AggFunc;
  showAggFunc?: (rowData: any[]) => boolean;
  showColumnFunc?: (rowData: any[]) => boolean;
}
